// Queue-first dispatch configuration.
//
// DISPATCH_TRIGGER decides WHEN the "Volgende bezoeker" pop-up opens on its
// own (it can always be opened manually from the NextUpWidget):
//
//   'pc_free'     — the moment a PC transitions running → free while visitors
//                   are waiting. The venue's starting policy.
//   'bijna_klaar' — already at the agent's stage-1 "Bezoeker is bijna klaar"
//                   notification, so the operator pre-assigns the PC before it
//                   is even free. Intended once operations smooth out — the
//                   listener is wired, flipping this constant is the only
//                   change needed.
export type DispatchTrigger = 'pc_free' | 'bijna_klaar';

export const DISPATCH_TRIGGER: DispatchTrigger = 'pc_free';

// Minimum time between two automatic pop-ups, so a burst of PCs finishing
// together doesn't stack modals. Manual opens are never throttled.
export const DISPATCH_COOLDOWN_MS = 5_000;
